export const RESET_FOCUS_AREA_ID = 'reset-focus-area';
